import hubNeighborhoods from './buildings-hub-neighborhoods.json';
import { buildingsHubUrl } from '@/utils/routes';

const HUB_NEIGHBORHOODS: ReadonlySet<string> = new Set(hubNeighborhoods);

/**
 * `/buildings/{borough}/{neighborhood}` when that hub page exists, else null.
 *
 * Several neighborhoods, mostly parent groupings such as "All Downtown" or
 * "Midtown West", have no hub: their URL redirects to `/buildings`. The list
 * is generated from the buildings SEO sitemaps (`pnpm gen:buildings-hubs`).
 */
export function neighborhoodHubUrl(
  borough: string | null | undefined,
  neighborhoodSlug: string | null | undefined,
): string | null {
  if (!borough || !neighborhoodSlug || !HUB_NEIGHBORHOODS.has(neighborhoodSlug)) return null;
  return buildingsHubUrl(borough, neighborhoodSlug);
}

export function hasNeighborhoodHub(neighborhoodSlug: string): boolean {
  return HUB_NEIGHBORHOODS.has(neighborhoodSlug);
}
